import autoSizeFromParentBoundsFactory from 'components/auto-size-from-parent-bounds';
import ChartItem from './chart-item';

const ChartItemWithAutoSize = autoSizeFromParentBoundsFactory(ChartItem);

export default ChartItemWithAutoSize;
export { ChartItemWithAutoSize as ChartItem };
